import styled from 'styled-components';
import Theme from '@adsk/alloy-react-theme';

type CellItemProps = {
  secondary?: boolean;
};
export const CellItem = styled.div<CellItemProps>((props) => ({
  ...Theme.typography.bodyMedium,
  ...Theme.typography.ellipsis,
  color: props.secondary ? Theme.colors.charcoal700 : 'inherit',
}));
